import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex'
    },
    label: {
        flexGrow: 1,
        margin: 'auto'
    },
    permissions: {
      display: 'flex'
    },
    permission: {
        minWidth: '6rem',
        textAlign: 'center'
    }
}));

const PermissionViewItem = ({
    availablePermissions,
    unit,
    explicitPermissions,
    inheritedPermissions,
    onChange
}: any) => {
    const classes = useStyles();
    const permission = explicitPermissions | inheritedPermissions;

    return (
               <div className={classes.root}>
                        <div className={classes.label}>{unit.name}</div>
                        <div className={classes.permissions} onClick={e => e.stopPropagation()}>
                {
                    availablePermissions.map((ap: any) => {

                                               return <div key={ap.toString()}
                                    className={classes.permission}>
                                {
                                                                       (permission & ap) === ap ? <CheckIcon /> : null
                                }
                        </div>
                    })
                }
            </div>
        </div>
    );
};

export default PermissionViewItem;
